import { render, staticRenderFns } from "./configOrgs.vue?vue&type=template&id=7ae9957d&scoped=true&"
import script from "./configOrgs.vue?vue&type=script&lang=js&"
export * from "./configOrgs.vue?vue&type=script&lang=js&"
import style0 from "./configOrgs.vue?vue&type=style&index=0&id=7ae9957d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae9957d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae9957d')) {
      api.createRecord('7ae9957d', component.options)
    } else {
      api.reload('7ae9957d', component.options)
    }
    module.hot.accept("./configOrgs.vue?vue&type=template&id=7ae9957d&scoped=true&", function () {
      api.rerender('7ae9957d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_gd_details/form/components/configOrgs.vue"
export default component.exports